
import React from 'react';
import { useTranslation } from 'react-i18next';
import MainLayout from '../components/Layout/MainLayout';
import NoticeBoard from '../components/NoticeBoard';

const Notices: React.FC = () => {
  const { t } = useTranslation();
  return (
    <MainLayout title={t('notices.pageTitle')}>
      <div className="p-4">
        <NoticeBoard />
      </div>
    </MainLayout>
  );
};

export default Notices;
